module.exports = __webpack_public_path__ + "static/img/voice1.699b6c28.png";